export const mixins = {

	data() {

		return {
		statusList: [{ //订单状态
				value: 10,
				text: "待接单",
				color: "#ef6b60"
			},{
				value: 11,
				text: "待车队确认",
				color:" #17B6A1"
			}, {
				value: 20,
				text: "待缴费",
				color:" #17B6A1"
			},
			{
				value: 30,
				text: "待审核",
				color:" #17B6A1"
			},
			{
				value: 31,
				text: "待磅房审核",
				color:" #17B6A1"
			},
			{
				value: 40,
				text: "作业中",
				color:" #17B6A1"
			}, {
				value: 42,
				text: "进卡口",
				color:" #17B6A1"
			}, {
				value: 43,
				text: "回皮",
				color:" #17B6A1"
			}, {
				value: 44,
				text: "装车",
				color:" #17B6A1"
			}, {
				value: 45,
				text: "过重",
				color:" #17B6A1"
			}, {
				value: 46,
				text: "无作业",
				color:" #17B6A1"
			}, {
				value: 60,
				text: "完成",
				color: "#b2b2b2"
			}, {
				value: 61,
				text: "拒绝接单",
				color: "#b2b2b2"
			}, {
				value: 62,
				text: "进场前取消",
				color: "#b2b2b2"
			}, {
				value: 63,
				text: '进场后取消',
				color: "#b2b2b2"
			}, {
				value: 64,
				text: "审核未通过",
				color: "#b2b2b2"
			}, {
				value: 65,
				text: "抢单车队拒绝",
				color: "#b2b2b2"
			}, {
				value: 66,
				text: "审核前取消",
				color: "#b2b2b2"
			}, {
				value: 49,
				text: "取消待审核",
				color: "#b2b2b2"
			}, {
				value: 68,
				text: "取消未通过",
				color: "#b2b2b2"
			}, {
				value: 69,
				text: "磅房取消",
				color: "#b2b2b2"
			}
		]
		};

	},

};